import * as UiUtil from "@/util/UiUtil";

export const getFieldLabel = () => {
  const domain = window.location.hostname;
  switch (domain) {
  case "ep.maot.co.kr":
    return "작업장명";
  case "nhsafe.maot.co.kr":
    return "현장명";
  default:
    return "사업장명";
  }
};

import config from "../../public/config";
import VueCookie from "vue-cookie";

/**
 * fetch 응답을 파일로 저장한다.
 * - 응답이 오류면 그 내용을 파일로 저장하지 않고 사유를 알린다
 * - 저장에 쓴 임시 링크와 URL 은 바로 정리한다
 *
 * @param {Response} response fetch 응답
 * @param {String} fileName 저장할 파일 이름
 */
export const saveResponseAsFile = async (response, fileName) => {
  if (!response.ok) {
    let message = "";
    try {
      const text = await response.text();
      try {
        const data = JSON.parse(text);
        message = typeof data === "string" ? data : (data && typeof data.message === "string" ? data.message : "");
      } catch (e) {
        message = text.length < 200 ? text : "";
      }
    } catch (e) { /* 본문을 읽지 못하면 기본 문구를 쓴다 */ }
    UiUtil.alertDialog(message || "파일을 내려받지 못했습니다.");
    return;
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // 다운로드가 시작된 뒤에 URL 을 해제한다
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};

export const downloadFile = (fileName, path) => {
  const hashedFileName = path.split("/").pop();

  const token = VueCookie.get("token");
  fetch(`${config.BASE_API_URL}/api/v1/file?hashedName=${hashedFileName}`, {
    headers: new Headers({
      Authorization: `Bearer ${token}`,
    }),
  }).then((response) => saveResponseAsFile(response, fileName));
};

let _loadDefragmentation_list = [];
const _loadDefragmentation = async ($store, apiType, options, useLoading) => {
  const response = await $store.dispatch(apiType, options);
  const list = [];
  list.push(...response.data);
  _loadDefragmentation_list.push(...response.data);
  if (useLoading) {
    UiUtil.loading(true, _loadDefragmentation_list.length, response.total);
  }
  if (response.current_page !== response.last_page) {
    options.page = response.current_page + 1;
    const _list = await _loadDefragmentation($store, apiType, options, useLoading);
    list.push(..._list);
    _loadDefragmentation_list.push(..._list);
  }
  return list
};

/**
 * 모든 페이지의 데이터를 불러온다.
 * @param $store
 * @param apiType
 * @param options
 * @returns {Promise<*[]>}
 */
export async function loadDefragmentation($store, apiType, options, useLoading) {
  _loadDefragmentation_list = [];
  if (useLoading) {
    UiUtil.loading(true);
  }
  const list = await _loadDefragmentation($store, apiType, options, useLoading)
  if (useLoading) {
    UiUtil.loading(false);
  }
  return list;
}

export function comma(str) {
  return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
